import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ScadenzarioRequest } from '../../../models/scadenzario-request';
import { Natura } from '../../../models/tipologiche/natura';
import { ScadenzaAutoAddFormComponent } from './scadenza-auto-add-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
  moduleId: module.id.replace('/dist/', '/'),
  selector: 'div [modale_aggiungi_scadenza_auto]',
  templateUrl: 'scadenza-mod-auto-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ScadenzaModAutoAddComponent {
  @Input() isAtto: boolean;
  @Input() isEsito: boolean;
  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('formScadenzarioAutoAdd') formScadenzarioAutoAdd: ScadenzaAutoAddFormComponent;


  inizializzaComponent(entita: any, ricercaEffettuata: ScadenzarioRequest, naturaFasciolo: Natura, idEntita: string, idFascicolo: string){
    this.formScadenzarioAutoAdd.inizializzaComponent(entita, ricercaEffettuata, naturaFasciolo, idEntita, idFascicolo);
    openModal('modalautoaddscad');
  }

  // CREAZIONE RAPIDA
  initFormCreazioneRapida(entita: any, ricercaEffettuata: ScadenzarioRequest, naturaFasciolo: Natura, idEntita: string, idFascicolo: string, modalName: string){
    this.formScadenzarioAutoAdd.inizializzaComponent(entita, ricercaEffettuata, naturaFasciolo, idEntita, idFascicolo);
    openModal(modalName);
  }

  manageModal(response) {
    if (response) {
      closeModal('modalautoaddscad');
      this.onReturn.emit(response);
    }
  }
}
